export default "https://cdn-static.gokick.com/assets/4215e61f258b66d5599ee2c3a2c4c86e46d29fa2/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";